import ArticleListTop from '../views/RegionArticle/ArticleList.vue';
let RegionArticle = [
  {
    path: 'ArticleListTop',
    name: '文章列表',
    component: ArticleListTop
  }
];

export default RegionArticle;
